import { inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VoiceFlowStateService } from '../voice-flow-state.service';
import { VoiceConfigurationData } from '../../../../../../../models/order/workflow/voice/voice-configuration.model';
import { AdditionalOfferData, OfferType } from '../../../../../../../models/order/workflow/additional-offer.model';

export const VOICE_DIRECTORY_LISTING_CODE = 'VOIP-DIRECTORY-LISTING';
export const VOICE_PORTING_OPTIONS_CODE = 'VOIP-PORTING-OPTIONS';
export const VOICE_PORTING_NEW_CODE = 'VOIP-PORTING-NEW';
export const VOICE_PORTING_ATT_CODE = 'VOIP-PORTING-ATT';
export const VOICE_PORTING_NONATT_CODE = 'VOIP-PORTING-NONATT';
export const MAX_VOICE_LINES = 6;

@Injectable({ providedIn: 'root' })
export class VoiceConfigurationStateService extends BaseWorkflowStateService<VoiceConfigurationData> {
    private flowStateService = inject(VoiceFlowStateService);
    protected override stateKey: string = 'voiceConfiguration';

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({
            voiceConfiguration: this.state(),
            voiceOffers: { offers: this.flowStateService.mergeVoiceOffers(this.buildOffers()) }
        });
    }

    private buildOffers(): AdditionalOfferData[] {
        const lines = this.state()?.lines || [];
        const directoryChoice = lines[0]?.directoryListingChoiceCode;
        const offers: AdditionalOfferData[] = [];

        for (const line of lines) {
            if (directoryChoice) {
                offers.push({
                    customizationCode: VOICE_DIRECTORY_LISTING_CODE,
                    choiceCode: directoryChoice,
                    usoc: directoryChoice,
                    type: OfferType.Voice
                });
            }
            if (line.numberOptionChoiceCode) {
                offers.push({
                    customizationCode: VOICE_PORTING_OPTIONS_CODE,
                    choiceCode: line.numberOptionChoiceCode,
                    usoc: line.numberOptionChoiceCode,
                    type: OfferType.Voice
                });
            }
        }

        return offers;
    }
}
